<ul class="flex-row-container filter-pills-list" aria-label="Applied search filters">
  @for (activeFilter of activeFilters; track activeFilter) {
    <li>
      <button
        class="filter-pill"
        (click)="removeFilter(activeFilter.filterType, activeFilter.filter)"
        id="remove-filter-{{ activeFilter.display }}"
      >
        <span class="visuallyhidden">Remove filter</span> {{ activeFilter.display | titlecase }}
        <i class="ico-cancel" aria-hidden="true"></i>
      </button>
    </li>
  }
</ul>
